export default "__VITE_ASSET__DWpfnNiK__"